<div class="alert" [ngClass]="type">
    <ng-content></ng-content>
</div>
